import React from 'react';
import MuiGrid, { GridProps } from '@material-ui/core/Grid/Grid';

const Grid = (props: GridProps) => (
  <MuiGrid
    classes={{
      root: ''
    }}
    {...props}
  >
    {props.children}
  </MuiGrid>
);

export default Grid;
